import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import CompsMap from './comps_map';
import { selectCompMarker, hideMapInfoBubble, toggleMapList } from './store/actions/ui';
import { getCurrentTab } from './store/selectors/ui';
import { toggleSelectLease, toggleSelectSale } from './store/actions/select_list';

export class CompsMapContainer extends React.Component {
  static propTypes = {
    activeComp: PropTypes.object,
    comps: PropTypes.array.isRequired,
    currentTab: PropTypes.oneOf(['lease', 'sale']).isRequired,
    googleMapsApiKey: PropTypes.string.isRequired,
    initialFetchComplete: PropTypes.bool.isRequired,
    mapMarkerPath: PropTypes.string.isRequired,
    markerAnchor: PropTypes.array.isRequired,
    markerClustererStyles: PropTypes.array.isRequired,
    selectedLeaseIds: PropTypes.array.isRequired,
    selectedSaleIds: PropTypes.array.isRequired,
    showInfoWindow: PropTypes.bool.isRequired,
    showMapList: PropTypes.bool.isRequired,
    toggleMapList: PropTypes.func.isRequired,
    toggleSelectLease: PropTypes.func.isRequired,
    toggleSelectSale: PropTypes.func.isRequired,
    onHideMapInfoBubble: PropTypes.func.isRequired,
    onSelectComp: PropTypes.func.isRequired
  };

  mappableComps = () => this.props.comps.filter((comp) => {
    return comp.latitude && comp.longitude &&
      (comp.latitude !== 0 && comp.longitude !== 0);
  });

  render() {
    const {
      activeComp,
      currentTab,
      googleMapsApiKey,
      initialFetchComplete,
      mapMarkerPath,
      markerAnchor,
      markerClustererStyles,
      selectedLeaseIds,
      selectedSaleIds,
      showInfoWindow,
      showMapList,
      toggleMapList,
      toggleSelectLease,
      toggleSelectSale,
      onHideMapInfoBubble,
      onSelectComp,
    } = this.props;

    const toggleSelectComp = currentTab === 'lease' ? toggleSelectLease : toggleSelectSale;
    const selectedCompIds = currentTab === 'lease' ? selectedLeaseIds : selectedSaleIds;

    return (
      <CompsMap
        activeComp={activeComp}
        comps={this.mappableComps()}
        googleMapsApiKey={googleMapsApiKey}
        initialFetchComplete={initialFetchComplete}
        mapMarkerPath={mapMarkerPath}
        markerAnchor={markerAnchor}
        markerClustererStyles={markerClustererStyles}
        overlay={!initialFetchComplete}
        selectedCompIds={selectedCompIds}
        showInfoWindow={showInfoWindow}
        showMapList={showMapList}
        toggleMapList={toggleMapList}
        toggleSelectComp={toggleSelectComp}
        onHideMapInfoBubble={onHideMapInfoBubble}
        onSelectComp={onSelectComp}
      />
    );
  }
}

const mapStateToProps = state => ({
  activeComp: state.ui.activeMapComp,
  googleMapsApiKey: state.ui.googleMapsApiKey,
  initialFetchComplete: state.search.initialFetchComplete,
  isFetching: state.search.isFetching,
  mapMarkerPath: state.paths.mapMarker,
  markerAnchor: state.ui.markerAnchor,
  markerClustererStyles: state.ui.markerClustererStyles,
  comps: state.search.meta.mapLocations,
  currentTab: getCurrentTab(state),
  selectedSaleIds: state.selectList.selectedSaleIds,
  selectedLeaseIds: state.selectList.selectedLeaseIds,
  showInfoWindow: state.ui.showMapInfoWindow,
  showMapList: state.ui.showMapList
});

const mapDispatchToProps = {
  toggleSelectLease,
  toggleSelectSale,
  toggleMapList,

  onSelectComp: selectCompMarker,
  onHideMapInfoBubble: hideMapInfoBubble
};

export default connect(mapStateToProps, mapDispatchToProps)(CompsMapContainer);
